<template>
    <ae-auth-model :hideForm="hideForm" :hasHideButton="hasHideButton">
        <b-row>
            <b-col v-if="isDesktop">
                <b-card class="card-form p-3 h-100" v-if="!sideSwitch">
                    <div class="text-center">
                        <b-img class="img-help mb-2" src="/static/img/icons/auth/idea.png"/>
                        <h5 class="text center text-primary font-weight-bold">Comment activer votre compte</h5>
                    </div>
                    <hr/>
                    <div>
                        <h5 class="title-section">Via E-mail:</h5>
                        <p class="text-justify">
                            Saisissez votre email professionnel.<br/>
                            <br/>
                            Cochez la case pour accepter les conditions générales d'utilisation puis cliquez sur
                            activer.<br/>
                            <br/>
                            Un mail vous sera alors envoyé avec un lien vous permettant de choisir votre mot de passe.
                        </p>
                    </div>
                    <div>
                        <p class="text-primary text-center">Vous n'avez pas d'e-mail ?</p>
                        <p class="text-justify">Actionnez le switch pour activer votre compte à l'aide de votre
                            matricule.</p>
                    </div>
                </b-card>
                <b-card class="card-form p-3 h-100" v-if="sideSwitch">
                    <div class="text-center">
                        <b-img class="img-help mb-2" src="/static/img/icons/auth/idea.png"></b-img>
                        <h5 class="text center text-primary font-weight-bold">Comment activer votre compte</h5>
                    </div>
                    <hr/>
                    <div>
                        <h5 class="title-section">Via matricule:</h5>
                        <p class="text-justify">
                            Saisissez votre matricule, l'email de votre choix et un numéro de téléphone.<br/>
                            <br/>
                            Cochez la case pour accepter les conditions générales d'utilisation puis cliquez sur
                            activer.<br/>
                            <br/>
                            Un mail vous sera alors envoyé avec un lien vous permettant de choisir votre mot de passe.
                        </p>
                    </div>
                    <div>
                        <p class="text-primary text-center">Vous n'arrivez pas à vous connecter ?</p>
                        <p class="text-justify">Contactez nous via le bouton "un problème pour activer votre compte?"
                            afin de vérifier les informations qui nous ont été fournies.</p>
                    </div>
                </b-card>
            </b-col>
            <b-col id="tab-pills" v-if="actionsButtons">
                <b-card id="auth&#45;&#45;form" class="card-form p-3 h-100">
                    <b-row class="d-flex justify-content-center">
                        <b-col :cols="isDesktop ? '2' : '3'" class="px-0">
                            <p :class="sideSwitch ? 'text-grey' : 'text-primary font-weight-bold'" class="m-0 pt-2 text-center cursor--pointer" @click="sideSwitch = false">Via E-mail</p>
                        </b-col>
                        <b-col cols="1" class="px-0 mx-1">
                            <b-form-checkbox switch size="lg" v-model="sideSwitch"></b-form-checkbox>
                        </b-col>
                        <b-col :cols="isDesktop ? '2' : '3'" class="px-0" :class="!isDesktop ? 'ml-2' : ''">
                            <p :class="sideSwitch ? 'text-primary font-weight-bold' : 'text-grey'" class="m-0 pt-2 text-center cursor--pointer" @click="sideSwitch = true">Via matricule</p>
                        </b-col>
                    </b-row>
                    <b-row class="px-3 pt-3" v-if="!sideSwitch">
                        <br/>
                        <b-form @submit.prevent="activationByEmail()" class="w-100">
                            <b-form-group label="Votre adresse E-mail" label-class="d-none d-lg-block">
                                <b-input-group>
                                    <b-input-group-text slot="prepend" class="br-0">
                                        <b-img class="icon-form" src="/static/img/icons/auth/mail.png"/>
                                    </b-input-group-text>
                                    <b-form-input id="aEmailEmail" type="email" placeholder="Saisissez votre e-mail"
                                                  v-model="email" required/>
                                </b-input-group>
                            </b-form-group>

                            <b-form-group>
                                <b-form-checkbox required>
                                    Accepter les
                                    <a :href="cgu" target="_blank">conditions générales d'utilisation</a>.
                                </b-form-checkbox>
                            </b-form-group>
                            <b-button variant="info" block type="submit" class="btn-activate-aes">Activer mon compte</b-button>
                        </b-form>
                    </b-row>
                    <b-row class="px-3" v-if="sideSwitch">
                        <br/>
                        <b-form @submit.prevent="activationByRegistrationNumber()">
                            <b-form-group label="Votre matricule professionnel" label-class="d-none d-lg-block">
                                <b-input-group>
                                    <b-input-group-text slot="prepend" class="br-0">
                                        <b-img class="icon-form"
                                               src="/static/img/icons/auth/business-and-finance.png"/>
                                    </b-input-group-text>
                                    <b-form-input id="aRNRN" type="text" placeholder="Saisissez votre matricule"
                                                  v-model="registrationNumber" required/>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label="Votre adresse e-mail" label-class="d-none d-lg-block">
                                <b-input-group>
                                    <b-input-group-text slot="prepend" class="br-0">
                                        <b-img class="icon-form"
                                               src="/static/img/icons/auth/mail.png"/>
                                    </b-input-group-text>
                                    <b-form-input id="aRNEmail" type="text"
                                                  placeholder="Saisissez l'e-mail de votre choix"
                                                  v-model="email" required/>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label="Votre numéro de téléphone" label-class="d-none d-lg-block">
                                <b-input-group>
                                    <b-input-group-text slot="prepend" class="br-0">
                                        <b-img class="icon-form"
                                               src="/static/img/icons/auth/telephone.png"/>
                                    </b-input-group-text>
                                    <b-form-input id="aRNPhoneNumber" type="text"
                                                  placeholder="Saisissez un numéro de téléphone"
                                                  v-model="phoneNumber" required/>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group>
                                <b-form-checkbox required>
                                    Accepter les
                                    <a :href="cgu" target="_blank">conditions générales d'utilisation</a>.
                                </b-form-checkbox>
                            </b-form-group>
                            <b-button variant="info" block type="submit">Activer mon compte</b-button>
                        </b-form>
                    </b-row>
                    <hr/>
                    <ul class="list-unstyled mb-0">
                        <li class="mb-2" v-if="!isDesktop">
                            <b-btn variant="dark" class="btn btn-dark btn-block" @click="showHelp">
                                <b-img class="img-help__btn" src="/static/img/icons/auth/idea.png"/>
                                Besoin d'aide ?
                            </b-btn>
                        </li>
                        <li class="mb-2">
                            <a href="mailto:support@alterego-sports.eu" class="btn btn-dark btn-block">Un problème pour
                                activer
                                votre compte ?</a>
                        </li>
                        <li>
                            <router-link :to="{ name: 'auth-login' }" class="btn btn-dark btn-block">J'ai déjà un compte
                                - Page
                                de connexion
                            </router-link>
                        </li>
                    </ul>
                </b-card>
            </b-col>

            <!--mobile help zone-->
            <b-col v-if="!isDesktop" id="help-zone-mobile" class="d-none">
                <b-card class="card-form p-3 h-100" v-if="!sideSwitch">
                    <div class="text-center">
                        <b-img class="img-help mb-2" src="/static/img/icons/auth/idea.png"/>
                        <h5 class="text center text-primary font-weight-bold">Comment activer votre compte</h5>
                    </div>
                    <hr/>
                    <div>
                        <h5 class="title-section">Via E-mail:</h5>
                        <p class="text-justify">
                            Saisissez votre email professionnel.<br/>
                            <br/>
                            Cochez la case pour accepter les conditions générales d'utilisation puis cliquez sur
                            activer.<br/>
                            <br/>
                            Un mail vous sera alors envoyé avec un lien vous permettant de choisir votre mot de passe.
                        </p>
                    </div>
                    <div>
                        <p class="text-primary text-center">Vous n'avez pas d'e-mail ?</p>
                        <p class="text-justify">Actionnez le switch pour activer votre compte à l'aide de votre
                            matricule.</p>
                    </div>
                    <div>
                        <b-btn @click="hideHelp" class="btn btn-dark btn-block">Retour page
                            d'activation
                        </b-btn>
                    </div>
                </b-card>
                <b-card class="card-form p-3 h-100" v-if="sideSwitch">
                    <div class="text-center">
                        <b-img class="img-help mb-2" src="/static/img/icons/auth/idea.png"></b-img>
                        <h5 class="text center text-primary font-weight-bold">Comment activer votre compte</h5>
                    </div>
                    <hr/>
                    <div>
                        <h5 class="title-section">Via matricule:</h5>
                        <p class="text-justify">
                            Saisissez votre matricule, l'email de votre choix et un numéro de téléphone.<br/>
                            <br/>
                            Cochez la case pour accepter les conditions générales d'utilisation puis cliquez sur
                            activer.<br/>
                            <br/>
                            Un mail vous sera alors envoyé avec un lien vous permettant de choisir votre mot de passe.
                        </p>
                    </div>
                    <div>
                        <p class="text-primary text-center">Vous n'arrivez pas à vous connecter ?</p>
                        <p class="text-justify">Contactez nous via le bouton "un problème pour activer votre compte?"
                            afin de vérifier les informations qui nous ont été fournies.</p>
                    </div>
                    <div>
                        <b-btn @click="hideHelp" class="btn btn-dark btn-block">Retour page
                            d'activation
                        </b-btn>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </ae-auth-model>
</template>

<script>
    import AeAuthModel from '@/components/AuthModel'
    import basicErrorHandler from '@/utils/handlers/basicErrorHandler'
    import apiResponseHandler from '@/utils/handlers/apiResponseHandler'
    import {AUTH_TMP_MAIL} from '@/utils/types/storage'

    const errors = {
        activationByEmail: {
            200: ['Activé', 'Un mail d\'activation vient de vous être envoyé.', 'success'],
            400: ['Invalide', 'Adresse e-mail inexistante.', 'error'],
            403: ['Déjà activé', 'Votre compte a déjà été activé, vous pouvez vous connecter.', 'warning']
        },
        activationByRegistrationNumber: {
            200: ['Activé', 'Un mail d\'activation vient de vous être envoyé.', 'success'],
            401: {
                'invalid_domain': ['Invalide', 'Le domaine sur lequelle vous êtes n\'est attaché à aucune OU de connexion.', 'warning'],
                'invalid_username': ['Invalide', 'Adresse e-mail ou matricule invalide.', 'error'],
                'duplicate': ['Invalide', 'La matricule que vous avez renseigné est enregistré en plusieurs fois dans nos services, veuillez contacter le support AlterEgo Sports pour pouvoir activer votre compte.', 'warning']
            },
            403: {
                'EmailExists': ['Invalide', 'Adresse e-mail déjà utilisée.', 'warning'],
                'ActiveAccount': ['Déjà activé', 'Votre compte a déjà été activé, vous pouvez vous connecter.', 'warning']
            },
            423: ['Compte bloqué', 'Votre compte est bloqué, impossible de l\'activer.', 'warning']
        }
    }

    export default {
        name: 'auth-activation',
        data: () => ({
            sideSwitch: false,
            cgu: 'https://www.alterego-sports.eu/fork.php?s=cgu',
            email: null,
            registrationNumber: null,
            phoneNumber: null,
            hideForm: false,
            hasHideButton: false,
            isDesktop: window.innerWidth > 768,
            actionsButtons: true
        }),
        components: {AeAuthModel},
        methods: {
            async activationByEmail() {
                try {
                    const {email} = this
                    const {status} = await this.$store.dispatch('base/auth/activateEmail', {email})
                    await apiResponseHandler(status, null, errors.activationByEmail)
                    if (status === 403)
                        this.handleAlreadyRegisteredRedirection(email)
                } catch (e) {
                    basicErrorHandler(e)
                }
            },
            async activationByRegistrationNumber() {
                try {
                    const {registrationNumber, email, phoneNumber} = this
                    const {status, statusText} = await this.$store.dispatch('base/auth/activateRegistrationNumber', {
                        registrationNumber,
                        email,
                        phoneNumber
                    })

                    await apiResponseHandler(status, statusText, errors.activationByRegistrationNumber)
                    if (status === 200)
                        this.handleAlreadyRegisteredRedirection(email)
                } catch (e) {
                    basicErrorHandler(e)
                }
            },
            handleAlreadyRegisteredRedirection(email) {
                window.localStorage.setItem(AUTH_TMP_MAIL, email)
                this.$router.push({name: 'auth-login'})
            },
            showHelp() {
                document.getElementById('tab-pills').classList.add('d-none')
                this.actionsButtons = !this.actionsButtons
                document.getElementById('help-zone-mobile').classList.remove('d-none')
            },
            hideHelp() {
                document.getElementById('help-zone-mobile').classList.add('d-none')
                this.actionsButtons = !this.actionsButtons
                document.getElementById('tab-pills').classList.remove('d-none')
            }
        }
    }
</script>

<style lang="scss">
    .input-group {
        border: 1px solid gray;
        border-radius: 5px;
        overflow: hidden;
    }

    .form-group label {
        font-weight: normal;
    }

    .form-group .form-control {
        background-color: #d8d1ca;
        border: none;
    }

    .auth--background .auth .auth--container {
        max-width: 100% !important;
    }

    .title-section {
        font-weight: bold;
        text-decoration: underline;
    }

    .img-help {
        width: 50px;
        height: 50px;

        &__btn {
            width: 20px;
            height: 20px;
        }
    }

    .card-form {
        background-color: rgba(255, 255, 255, 0.9);
    }

    .icon-form {
        width: 15px;
        height: 15px;
    }

    .custom-switch .custom-control-label::before {
        color: #fff;
        border-color: #006699;
        background-color: #006699;
    }

    .custom-switch .custom-control-label::after {
        background-color: #dee2e6;
    }

    .text-grey {
        color: grey;
    }
    .btn-activate-aes{
      background-color: #00bc90 !important;
      border-color: #00bc90 !important;
    }
</style>
